import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  ASAP: {
    defaultMessage: 'ASAP',
    id: 'lZT7T9',
    description: 'Pickup dropdown option ASAP',
  },
  custom: {
    defaultMessage: 'Custom Date/Time...',
    id: 'nJ4Q9r',
    description: 'Pickup dropdown option custom',
  },
  dateToday: {
    defaultMessage: 'Today, {display}',
    id: 'jy62Ml',
    description: 'Pickup dropdown option Today',
  },
  label: {
    defaultMessage: 'Pickup',
    description: 'fulfillmentPlanner.pickup',
    id: 'EBZMI/',
  },
});
